<template>
  <div class="cards">
    <article :class="quote.className" class="card" :key="quote.id" v-for="quote in quotes">
      <div class="card__header user">
        <div class="user__photo">
          <img
            :src="require(`../../../assets/testimonials/${quote.img_url}`)"
            :alt="quote.name"
          />
        </div>
        <div class="user__details">
          <p class="user__name"> {{quote.name}} </p>
          <p class="user__status"> {{quote.status}} </p>
        </div>
      </div>

      <h3 class="card__title">{{quote.title}}</h3>
      <p class="card__text">{{quote.text}}</p>
    </article>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    quotes: Array,
  },
};
</script>

<style lang="scss" scoped>

.cards {
  @media (min-width: 75em) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas: "a a b c" "d e e c";
    gap: 2rem;
  }
}

.card {
  padding: 1.5rem;
  margin: 1rem auto;
  border-radius: 0.5rem;
  box-shadow: 0 0 15px 3px rgba(25,25,25, 0.4);

  @media (min-width: 75em) {
    margin: 0 auto;
  }

  &__title {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1;
  }

  &__text {
    line-height: 1.4;
    opacity: 0.5;
    font-size: 0.95rem;

    &::before {
      content: '" ';
    }

    &::after {
      content: ' "';
    }
  }

  transition: all 350ms linear;

  &:hover {
    box-shadow: 0 0 5px 1px rgba(25,25,25, 0.1);
    cursor: pointer;
  }

  &__title {
    margin: 1rem 0;
  }

  &--violate {
      background-color: var(--moderate-violet);
      color: white;
      position: relative;
      grid-area: a;

      &::after {
        content: "";
        background: no-repeat url(../../../assets/testimonials/bg-pattern-quotation.svg);
        background-size: cover;
        position: absolute;
        top: 1rem;
        right: 3rem;
        height: 6rem;
        width: 6rem;
        z-index: 1;

        @media (min-width: 40em) {
          left: 70%;
        }
      }
  }

  &--violate .card__title {
    position: relative;
    z-index: 2;
    grid-area: a;
  }

  &--light-dark-blue {
    background-color: var(--very-dark-grayish-blue);
    color: white;
  }

  &--1-white,
  &--2-white {
    background-color: white;
    color: var(--very-dark-grayish-blue);
  }

  &--1-white {
    grid-area: c;
  }

  &--2-white {
    grid-area: d;
  }

  &--dark-blue {
    background-color: var(--very-dark-blackish-blue);
    color: white;
    grid-area: e;
  }

  .user {
    display: flex;
    column-gap: 1.5rem;

    &__status {
      opacity: 0.5;
    }

    &__photo > img {
       width: 32px;
       height: 32px;
       border-radius: 50%;
    }
  }
}
</style>
